import { Box, Typography } from '@mui/material';
import { bool, node, string } from 'prop-types';
import React from 'react';

const ToolPanelSection = ({
  title,
  description = null,
  action = null,
  children,
  flush = false,
}) => (
  <Box
    sx={{
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'divider',
      borderRadius: '8px',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        p: 2,
        px: 2.5,
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, minWidth: 0 }}>
        <Typography
          component="h3"
          sx={{
            fontSize: theme => theme.typography.pxToRem(15),
            fontWeight: 600,
            color: 'text.primary',
            lineHeight: 1.3,
          }}
        >
          {title}
        </Typography>
        {description && (
          <Typography
            component="p"
            sx={{
              fontSize: theme => theme.typography.pxToRem(12.5),
              color: 'text.secondary',
              lineHeight: 1.45,
              maxWidth: 700,
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
      {action}
    </Box>
    <Box sx={flush ? { p: 0 } : { p: 2.5 }}>{children}</Box>
  </Box>
);

ToolPanelSection.propTypes = {
  title: string.isRequired,
  description: string,
  action: node,
  children: node.isRequired,
  flush: bool,
};

export default ToolPanelSection;
